import { z } from 'zod';

// Cores de avatar pré-definidas (paleta categórica do design system).
export const AVATAR_COLORS = [
  '#e96a45',
  '#d97706',
  '#3d8f5f',
  '#3b82f6',
  '#6366f1',
  '#8b5cf6',
  '#ec4899',
  '#6b7280',
] as const;

export const profileUpdateSchema = z.object({
  name: z.string().min(2, 'Nome muito curto').max(120),
  cargo: z.string().max(120).optional().or(z.literal('')),
  avatar_color: z.enum(AVATAR_COLORS).optional(),
});
export type ProfileUpdateInput = z.infer<typeof profileUpdateSchema>;

export const passwordChangeSchema = z
  .object({
    current_password: z.string().min(1, 'Senha atual obrigatória'),
    new_password: z
      .string()
      .min(8, 'Mínimo 8 caracteres')
      .regex(/[A-Z]/, 'Precisa de 1 letra maiúscula')
      .regex(/\d/, 'Precisa de 1 número'),
    confirm_password: z.string().min(1, 'Confirme a nova senha'),
  })
  .refine((v) => v.new_password === v.confirm_password, {
    path: ['confirm_password'],
    message: 'Senhas não coincidem',
  });
export type PasswordChangeInput = z.infer<typeof passwordChangeSchema>;

export const notifPrefsSchema = z.object({
  notif_sla: z.boolean().default(true),
  notif_documentos: z.boolean().default(true),
  notif_atribuidos: z.boolean().default(true),
});
export type NotifPrefs = z.infer<typeof notifPrefsSchema>;

export const sessionSchema = z.object({
  ip: z.string(),
  ua: z.string(),
  created_at: z.string(),
  is_current: z.boolean().default(false),
});
export type Session = z.infer<typeof sessionSchema>;

export const sessionsResponseSchema = z.array(sessionSchema);

export const okSchema = z.object({ ok: z.boolean() });

// Re-export do User para o módulo (fonte única em lib/auth).
export { userSchema, type User } from '@/lib/auth';
